import { FC, memo } from 'react';
import { useLocation } from 'react-router-dom';
import OperationDirectionsComponent from 'src/components/OperationDirectionsComponent';

import OperationDirectionPresenter from './OperationDirectionPresenter';

const OperationDirections: FC = memo(() => {
  const query = new URLSearchParams(useLocation().search);

  const shiftIds = query.get('ids').split(',').map((id) => Number(id));
  const queryAction = query.get('action');
  const action: '積' | '降' | null = queryAction
    ? ['積', '降']
      .find((str) => str === queryAction) as '積' | '降'
    : null;
  const variantParam = query.get('variant');
  const variant: 'v2' | 'v3' = variantParam === 'v3' ? 'v3' : 'v2';
  // 省略表示（印刷ごとの一時設定。既定 OFF）。「納品のみ表示する」と同じ URL パラメータ方式。
  const truncate = query.get('truncate') === '1';

  return (
    <OperationDirectionsComponent
      shiftIds={shiftIds}
      presenter={OperationDirectionPresenter}
      action={action}
      variant={variant}
      truncate={truncate}
    />
  );
});

export default OperationDirections;
